<template>
  <div>
    <agent-form
      v-if="isAgent(partyInfo) || (isRepresentativeRole(partyInfo) && isPersonType(partyInfo))"
      :agent-social-id="formModel.socialId"
      :form-model="partyInfo"
      :view-mode="viewMode"
    ></agent-form>

    <lawyer-form
      v-if="isLawyer(partyInfo)"
      :lawyer-social-id="formModel.socialId"
      :form-model="partyInfo"
      :view-mode="viewMode"
    ></lawyer-form>

    <guardian-form
      v-if="isGuardian(partyInfo)"
      :guardian-social-id="formModel.socialId"
      :guardian-birth-date="formModel.dateOfBirth"
      :form-model="partyInfo"
      :view-mode="viewMode"
    ></guardian-form>

    <regent-form
      v-if="isRegent(partyInfo)"
      :regent-social-id="formModel.socialId"
      :form-model="partyInfo"
      :view-mode="viewMode"
    ></regent-form>

    <liquidator-form
      v-if="isLiquidatorOrJudicialGuardRole(partyInfo)"
      :liquidator-social-id="formModel.socialId"
      :form-model="partyInfo"
      :view-mode="viewMode"
    ></liquidator-form>

    <company-representative-form
      v-if="isRepresentativeRole(partyInfo) && isCompanyType(partyInfo) && !isPersonType(partyInfo)"
      :representative-social-id="formModel.socialId"
      :form-model="partyInfo"
      :view-mode="viewMode"
    ></company-representative-form>

    <government-representative-form
      v-if="isRepresentativeRole(partyInfo) && !isCompanyType(partyInfo) && !isPersonType(partyInfo)"
      :representative-social-id="formModel.socialId"
      :form-model="partyInfo"
      :view-mode="viewMode"
    ></government-representative-form>
    <cessation-form
      v-if="isCessationObserver(partyInfo)"
      :form-model="partyInfo"
      :is-supervision-document="true"
      :required="true"
    >
    </cessation-form>
  </div>
</template>

<script>
import AgentForm from './agent-form';
import cessationForm from './cessation-form.vue';
import GuardianForm from './guardian-form';
import LawyerForm from './lawyer-form';
import LiquidatorForm from './liquidator-form.vue';
import GovernmentRepresentativeForm from './government-representative-form';
import CompanyRepresentativeForm from './company-representative-form';
import RegentForm from './regent-form';
import {
  isAgent,
  isLawyer,
  isGuardian,
  isRegent,
  isLiquidatorOrJudicialGuardRole,
  isRepresentativeRole,
  isCessationObserver,
} from '../../../../helpers/utils';
import { partyTypeEnum } from '@/helpers/enum';

export default {
  inject: ['$validator'],
  components: {
    GovernmentRepresentativeForm,
    CompanyRepresentativeForm,
    AgentForm,
    RegentForm,
    LawyerForm,
    GuardianForm,
    LiquidatorForm,
    cessationForm,
  },
  props: ['formModel', 'partyInfo', 'required', 'viewMode'],
  data() {
    return {
      partyTypeEnum,
      isAgent,
      isLawyer,
      isGuardian,
      isRegent,
      isLiquidatorOrJudicialGuardRole,
      isRepresentativeRole,
      isCessationObserver,
    };
  },
  watch: {
    'partyInfo.casePartyRole'() {
      var props = ['isVerified', 'attorneyTypeId', 'attorneyNumber', 'externalAttorneySourceId', 'isApprovedFromMofa', 'isApprovedFromMoj', 'isRelative', 'relativeDescription', 'isTraineeLawyer', 'mainLawyerSocialId', 'mainAttorneyNumber', 'minorTypeId', 'relativeTypeId', 'guardianshipNumber', 'regencyNumber', 'isManualDeed', 'judgementCode', 'judgementDate', 'judgementSourceId', 'letterDate', 'letterSourceId', 'letterSourceName', 'letterNumber'];
      props.forEach((prop) => { this.$set(this.partyInfo, prop, undefined); });
    },
  },
  methods: {
    isCompanyType(partyInfo) {
      const companyTypes = {
        [this.partyTypeEnum.person]: partyInfo.isOrganizationOwner,
        [this.partyTypeEnum.foreignCompany]: true,
        [this.partyTypeEnum.firm]: true,
        [this.partyTypeEnum.organization]: true,
      };
      return companyTypes[partyInfo.relatedPartyType];
    },
    isPersonType(partyInfo) {
      const companyTypes = { [this.partyTypeEnum.person]: !partyInfo.isOrganizationOwner };
      return companyTypes[partyInfo.relatedPartyType];
    },
  },
};
</script>
